<template>
  <b-card style="padding:40px;">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
    <h5><b>CREATE USER</b></h5>
    <hr />
    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-name`"
            >Name <span class="danger-new">*</span></label
          >
          <b-form-input
            v-model="form.name"
            :id="`input-name`"
            :type="`text`"
            class="input-new"
          ></b-form-input>
          <p v-if="error.name">
            <span class="danger-new">{{ this.error.name }}</span>
          </p>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Date Of Birth</label>
          <b-form-input
            v-model="form.dob"
            :id="`input-role`"
            :type="`date`"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Company Name</label>
          <b-form-input
            v-model="form.comp_name"
            :id="`input-role`"
            :type="`text`"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`"
            >Role <span class="required">*</span></label
          >
          <b-form-select
            v-model="form.role"
            :options="role"
            @change="changeRole"
          ></b-form-select>
          <p v-if="error.role">
            <span class="danger-new">{{ this.error.role }}</span>
          </p>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group
          v-if="form.role == '3' || form.role == '4' || form.role == '5'"
        >
          <label v-if="form.role == '3'" :for="`input-role`"
            >Stokist Name</label
          >
          <label v-if="form.role == '4'" :for="`input-role`"
            >Home Dealer Name</label
          >
          <multiselect
            v-model="form.upline"
            :options="upline"
            placeholder="Please select"
            label="name"
            track-by="name"
          ></multiselect>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <b-form-group>
          <label :for="`input-adress`"
            >Address <span class="danger-new">*</span></label
          >
          <b-form-input
            v-model="form.add1"
            :id="`input-add1`"
            :type="`text`"
            maxlength="100"
            class="input-new"
          ></b-form-input>
          <p v-if="error.add1">
            <span class="danger-new">{{ this.error.add1 }}</span>
          </p>
          <br />
          <b-form-input
            v-model="form.add2"
            :id="`input-add2`"
            :type="`text`"
            maxlength="100"
            class="input-new"
          ></b-form-input>
          <br />
          <b-form-input
            v-model="form.add3"
            :id="`input-add3`"
            :type="`text`"
            maxlength="100"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-state`"
            >State <span class="danger-new">*</span></label
          >
          <b-form-select v-model="form.state" :options="state"></b-form-select>
          <p v-if="error.state">
            <span class="danger-new">{{ this.error.state }}</span>
          </p>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-city`"
            >City <span class="danger-new">*</span></label
          >
          <b-form-input
            v-model="form.city"
            :id="`input-city`"
            :type="`text`"
            class="input-new"
          ></b-form-input>
          <p v-if="error.city">
            <span class="danger-new">{{ this.error.city }}</span>
          </p>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`"
            >Postcode <span class="danger-new">*</span></label
          >
          <b-form-input
            v-model="form.postcode"
            :id="`input-role`"
            :type="`number`"
            class="input-new"
          ></b-form-input>
          <p v-if="error.postcode">
            <span class="danger-new">{{ this.error.postcode }}</span>
          </p>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`"
            >Email <span class="danger-new">*</span></label
          >
          <b-form-input
            v-model="form.email"
            :id="`input-role`"
            :type="`email`"
            class="input-new"
          ></b-form-input>
          <p v-if="error.email">
            <span class="danger-new">{{ this.error.email }}</span>
          </p>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-phone_no`">Phone Number</label>
          <b-form-input
            v-model="form.phone_no"
            :id="`input-phone_no`"
            :type="`number`"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-accno`">Account No.</label>
          <b-form-input
            v-model="form.accno"
            :id="`input-accno`"
            :type="`text`"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-credit`">Credit Terms</label>
          <b-form-input
            v-model="form.credit_terms"
            :id="`input-credit`"
            :type="`text`"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="onClickSaving"
          >SAVE</b-button
        >
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      form: {
        name: "",
        dob: "",
        comp_name: "",
        add1: "",
        add2: "",
        add3: "",
        city: "",
        postcode: "",
        email: "",
        phone_no: "",
        state: "",
        role: "",
        chiller: "",
        upline: "",
        credit_terms: "",
        accno: ""
      },
      state: [],
      role: [],
      upline: [],
      error: {
        name: "",
        role: "",
        add1: "",
        state: "",
        city: "",
        postcode: "",
        email: ""
      },
      isLoading: false,
      fullPage: true
    };
  },

  components: {
    Loading
  },

  created() {
    this.getReftable();
    // this.getUpline();
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
    getUpline() {
      this.upline = [];
      this.$store.dispatch("getUpline").then(res => {
        res.data.data.forEach(element => {
          this.upline.push({
            id: element.user_id,
            name: element.name
          });
        });
      });
    },
    getHD() {
      this.upline = [];
      this.$store.dispatch("getHomeDealer").then(res => {
        res.data.data.forEach(element => {
          this.upline.push({
            id: element.user_id,
            name: element.name
          });
        });
      });
    },
    getReftable() {
      this.$store.dispatch("getReftable", "state").then(res => {
        res.data.data.state.forEach(element => {
          this.state.push({
            value: element.ref_code,
            text: element.desc
          });
        });
      });
      this.$store.dispatch("getReftable", "role").then(res => {
        res.data.data.role.forEach(element => {
          this.role.push({
            value: element.ref_code,
            text: element.desc
          });
        });
      });
    },
    onClickSaving() {
      this.error.name = "";
      this.error.role = "";
      this.error.add1 = "";
      this.error.state = "";
      this.error.city = "";
      this.error.postcode = "";
      this.error.email = "";
      this.checkForm();
      const form = {
        name: this.form.name,
        dob: this.form.dob,
        company: this.form.comp_name,
        add1: this.form.add1,
        add2: this.form.add2,
        add3: this.form.add3,
        city: this.form.city,
        postcode: this.form.postcode,
        email: this.form.email,
        phone_no: this.form.phone_no,
        chiller: this.form.chiller,
        access_lvl: this.form.role,
        state: this.form.state,
        upline_id: this.form.upline.id,
        user_id: null,
        accno: this.form.accno,
        credit_terms: this.form.credit_terms
      };
      this.isLoading = true;
      this.$store
        .dispatch("createUser", form)
        .then(res => {
          if (res.data.response.code === 1) {
            this.isLoading = false;
            this.$router.go(-1);
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.error.email = "Email already registered";
        });
    },
    changeRole() {
      if (this.form.role == 3) {
        this.getUpline();
      } else if (this.form.role == 4) {
        this.getHD();
      }
    },
    checkForm: function(e) {
      if (
        this.form.name &&
        this.form.role &&
        this.form.add1 &&
        this.form.state &&
        this.form.city &&
        this.form.postcode &&
        this.form.email
      )
        return true;
      this.error.name = "";
      this.error.role = "";
      this.error.add1 = "";
      this.error.state = "";
      this.error.city = "";
      this.error.postcode = "";
      this.error.email = "";

      if (!this.form.name) this.error.name = "Name required.";
      if (!this.form.role) this.error.role = "Role required.";
      if (!this.form.add1) this.error.add1 = "Address required.";
      if (!this.form.state) this.error.state = "State required.";
      if (!this.form.city) this.error.city = "City required.";
      if (!this.form.postcode) this.error.postcode = "Postcode required.";
      if (!this.form.email) this.error.email = "Email required.";
      e.preventDefault();
    }
  }
};
</script>

<style lang="css" scoped></style>
